// Styles
import './Promotions.scss';

// Libs
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Common
import Price from '@/common/components/blocks/Price/Price';

import {
  PromotionsDefaultProps,
  PromotionsPropTypes,
} from './Promotions.proptypes';

const Promotions = ({ className, discountClasses, isUpdated }) => {
  const { t } = useTranslation();

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['promotions', className].filter((val) => val).join(' '),
    [className],
  );

  /**
   * Return step depends on isUpdated
   * missing_amount is null : max step position, so get data from current_step
   * missing_amount is not null > use next_step. Filtering steps to get the percentage
   * @param {object} currentStep { level: number, percentage: number }
   * @param {object} nextStep { level: number, percentage: number }
   * @param {number} missingAmount
   * @param {array} steps
   */
  const getNextStep = useCallback(
    (currentStep, nextStep, missingAmount) => {
      if (isUpdated) {
        return '--';
      }
      if (missingAmount) {
        return nextStep?.percentage;
      }
      return currentStep?.percentage;
    },
    [isUpdated],
  );

  if (discountClasses && discountClasses.length > 0) {
    return (
      <div className={classNames}>
        <ul className="promotions__title">
          <li className="title" data-qa-id="promotions-name">
            {t('ebat:entities:cart.promotions.name')}
          </li>
          <li className="title title--missing">
            {t('ebat:entities:cart.promotions.missing')}
          </li>
          <li className="title title--next">
            {t('ebat:entities:cart.promotions.next')}
          </li>
        </ul>
        <ul className="promotions__content" data-qa-id="promotions">
          {discountClasses.map((item) => {
            const {
              current_step: currentStep,
              label,
              missing_amount: missingAmount,
              next_step: nextStep,
            } = item;

            return (
              <li
                className="promotion"
                key={`promotion-${item.code}`}
                data-qa-id="promotions-item"
              >
                <div className="promotion__title" data-qa-id="promotion-label">
                  {label}
                </div>
                <div className="promotion__missing">
                  <span className="label">Manquant pour prochaine remise</span>
                  <span className="value">
                    <Price
                      context="promotion-missing-amount"
                      value={missingAmount || nextStep?.level || 0}
                      sup={false}
                    />
                  </span>
                </div>
                <div className="promotion__next">
                  <span className="label">Prochaine remise</span>
                  <span className="value" data-qa-id="promotion-next">
                    {getNextStep(currentStep, nextStep, missingAmount)} %
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return null;
};

Promotions.defaultProps = {
  ...PromotionsDefaultProps,
};

Promotions.propTypes = {
  ...PromotionsPropTypes,
};

export default Promotions;
